angular.module("registrationModule").component("registrationEmailPassword", {
	templateUrl: "registrationEmailPassword/registrationEmailPassword.html",
	bindings: {
		onTrackStep: "&",
		onContinueToSignIn: "&",
		onValidateEmail: "&",
		onSignUp: "&",
		onClose: "&",
		user: "<",
		adDesignVersion: "<",
		errorMessages: "<",
	},
	controller: ["$document", "$timeout", "$sce", "$element", "patterns", function($document, $timeout, $sce, $element, patterns) {
		var self = this;
		this.patterns = patterns;
		this.userEmailHasChanged = false;
		this.registrationNamePattern = /^[A-Za-zÀ-ÖØ-öø-ÿ]{2,}(\s+[A-Za-zÀ-ÖØ-öø-ÿ]{2,})+$/;

		this.submit = function () { // Validating email (if it exists) and registering user
			if ((typeof this.form.needsValidation === "undefined") || this.form.needsValidation) {
				this.validateEmail(this.user, this.form, function () { self.submit(); });
			} else if (this.form.$valid) {
				this.onSignUp({form: this.form});
			}
		};

		this.continueToSignIn = function ($event) { // This is back button
			$event.preventDefault();
			this.onContinueToSignIn();
		};

		this.validateEmail = function(user, form, callback) {
			this.onValidateEmail({user: user, form: form, callback: callback});
		};

		this.$onDestroy = function() {
			$document.off("click", self.closeHandler);
		};

		this.closeHandler = function(e) {
			if ($element !== e.target && !$element[0].contains(e.target)) {
				$timeout(function () { self.onClose();});
			}
		};

		this.fieldChange = function(key) {
			this.userEmailHasChanged = true;

			if (!this.form[key].$valid) {
				this.form[key].$setValidity(key + "Exist", true);
				this.form[key].$setValidity(key + "Short", true);
				this.form[key].$setValidity(key + "Global", true);
			}

			if (this.form.globalErrors && this.form.globalErrors.length > 0) {
				this.form.globalErrors = [];
			}
			this.form.needsValidation = true;
		};
	}]
});
